<div class="tile tile--z-3" (click)="routeToReport()">
  <div class="tiletitle">{{title | translate}}</div>
  <img src="{{image}}">
</div>
